import PopConfirm from './pop-confirm';

export default PopConfirm;
export type * from './types';
